// TODO: Delete this file once real agents are implemented and placeholders are removed
import { Bot, DollarSign, Home, Briefcase, FileText, RefreshCw, User, Wifi } from "lucide-react";
import { Button } from "@/components/ui/button";

type PlaceholderAgentCardProps = {
  name: string;
  description?: string;
  icon?: "robot" | "dollar" | "home" | "briefcase" | "file" | "user";
  capabilities?: string[];
  whatsappNumber?: string;
};

const getIcon = (iconType: PlaceholderAgentCardProps["icon"]) => {
  switch (iconType) {
    case "dollar":
      return DollarSign;
    case "home":
      return Home;
    case "briefcase":
      return Briefcase;
    case "file":
      return FileText;
    case "user":
      return User;
    default:
      return Bot;
  }
};

const PlaceholderAgentCard = ({
  name,
  description = "Especializado en ventas y arriendos",
  icon = "robot",
  capabilities = [],
  whatsappNumber = "15402742516",
}: PlaceholderAgentCardProps): JSX.Element => {
  const AgentIcon = getIcon(icon);

  return (
    <div className="relative flex h-full w-full flex-col rounded-lg border-2 border-gray-200 bg-white p-6 transition-all duration-200 hover:-translate-y-px hover:border-gray-300 hover:shadow-[0px_2px_12px_rgba(0,0,0,0.08)]">
      {/* Agent icon and name */}
      <div className="mb-3 flex items-center gap-3 rounded bg-gray-50 p-2">
        <div className="flex items-center justify-center rounded-md bg-[#5C28F5] p-2">
          <AgentIcon className="size-5 text-white" />
        </div>
        <p className="text-lg font-bold text-gray-800">
          {name}
        </p>
      </div>

      {/* Status badges */}
      <div className="mb-3 flex items-center gap-2">
        <span className="rounded-full bg-[#E3FFE4] px-2.5 py-0.5 text-xs font-medium text-[#2D8A3F]">
          Popular
        </span>
        <span className="flex items-center gap-1 rounded-full bg-[#E3FFE4] px-2.5 py-0.5 text-xs font-medium text-[#2D8A3F]">
          <Wifi className="size-3" />
          Online
        </span>
      </div>

      {/* WhatsApp phone number */}
      <div className="mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-600">WhatsApp:</span>
          <span className="text-sm font-semibold text-gray-700">{whatsappNumber}</span>
        </div>
      </div>

      {/* Connect/Change WhatsApp button */}
      <Button
        size="sm"
        variant="outline"
        className="mb-3 w-full cursor-default"
      >
        <RefreshCw className="mr-2 size-4" />
        Cambiar WhatsApp
      </Button>

      {/* Agent description */}
      <p className="mb-3 grow text-sm leading-relaxed text-gray-600">
        {description}
      </p>

      {/* Agent capabilities */}
      {capabilities.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {capabilities.map((capability, index) => (
            <span key={index} className="rounded bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-800">
              {capability}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default PlaceholderAgentCard;
